import { useState, useMemo } from "react";
import Carousel from "react-spring-3d-carousel";
import { config } from "react-spring";

export const PosterCarousel = ({ posters }) => {
  const [goToSlide, setGoToSlide] = useState(0);

  const slides = useMemo(() => {
    if (!posters || !posters.length) return [];

    return posters.map((poster, index) => ({
      key: `poster-${index}`,
      content: (
        <PosterSlide
          poster={poster}
          index={index}
          onClick={() => setGoToSlide(index)}
        />
      ),
    }));
  }, [posters]);

  if (!slides.length) return null;

  return (
    <div
      id="caro"
      style={{
        width: "auto",
        height: "60vh",
        margin: "0 auto",
      }}
    >
      <Carousel
        goToSlide={goToSlide}
        goToSlideDelay={200}
        slides={slides}
        offsetRadius={4}
        showNavigation={true}
        animationConfig={config.wobbly}
      />
    </div>
  );
};

const PosterSlide = ({ poster, index }) => {
  const pdfUrl = poster.posterPDF?.asset?.url || '';
  const imageUrl = poster.posterJPG?.asset?.url || '';
  const hasPdf = Boolean(pdfUrl);

  return (
    <a
      target="_blank"
      rel="noreferrer noopener"
      href={hasPdf ? pdfUrl : '#'}
      style={{
        height: "100%",
        alignItems: "center",
        display: "flex",
        pointerEvents: hasPdf ? "auto" : "none",
      }}
    >
      <img
        src={imageUrl}
        alt={`Poster ${index}`}
        style={{ width: "80vw" }}
      />
    </a>
  );
};
